import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

const GuardRouter: React.FC<any> = (props) => {
  return <Router>{props.children}</Router>;
};

export default GuardRouter;
